import { useMutation, useQueryClient, InfiniteData } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { KnowledgeBaseApi } from '@/Domain/api/KnowledgeBase/KnowledgeBase.api';
import { ArticleDto, ParagraphDto } from '@/Domain/api/KnowledgeBase/dto/Article.dto';

export const useRemoveParagraph = () => {
  const { t } = useTranslation('paragraphs');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.knowledgeBase.articles.delete}-delete`],
    mutationFn: (id: number) => KnowledgeBaseApi.deleteArticle(id),
    onSuccess: (_, id) => {
      queryClient.setQueriesData(
        { queryKey: [Endpoint.knowledgeBase.paragraphs] },
        (
          prevData:
            | InfiniteData<{ items: (ParagraphDto | ArticleDto)[]; count: number }>
            | undefined,
        ) => {
          if (!prevData) return prevData;

          return {
            ...prevData,
            pages: prevData.pages.map((page) => ({
              ...page,
              count: page.count - 1,
              items: page.items.filter((paragraph) => paragraph.id !== id),
            })),
            pageParams: prevData.pageParams,
          };
        },
      );

      toast.success(t('toast.delete'));
    },
  });

  const handleRemoveParagraph = (id: number) => mutation.mutate(id);

  return {
    ...mutation,
    handleRemoveParagraph,
  };
};
